/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Product} from '../../../core/_models'
import {formatDateTime} from '../../../../../utils/dayJs/format'

type Props = {
  product: Product
}

const UpdatedInCell: FC<Props> = ({product}) => (
  <div className='d-flex flex-column'>
    {product.updatedAt ? formatDateTime(product.updatedAt.toString()) : 'N/A'}
    {/* <span>{franchise.updatedAt ? franchise.updatedAt.toString() : 'N/A'}</span> */}
  </div>
)

export {UpdatedInCell}
